import React from 'react';
import CpfInput from '../../inputs/CpfInput';
import server from '../../server';
import CreateAppointment from '../../panels/CreateAppointment';
import TelephoneInput from '../../inputs/TelephoneInput';
import EmailInput from '../../inputs/EmailInput';
import {LockModal} from './Modals' 
import {Calendar} from './Calendar';

function range(startAt = 0, size, step = 1) {
    let numbers = [];
    for(let i = startAt; i < size; i += step){
        numbers.push(i);
    }
    return numbers;
}

function hour_to_Min(hour){
    let split = hour.split(":");
    return parseInt(split[0]) * 60 + parseInt(split[1]);
}

function min_to_Hour(minutes){
    let hourText = Math.floor(minutes / 60);
    let minutesText = (minutes % 60);

    if (hourText < 10)
        hourText = "0" + hourText;

    if (minutesText < 10)
        minutesText = "0" + minutesText;

    return hourText + ":" + minutesText;
}

function get_actual_day(day){
    if(day == 0) return 7;
    return day;
}

class PatientRegister extends React.Component{
    state = {}

    render(){
        return(
            <div class="mB-30 form-row">
                <br/>
                <div class="form-group col-md-12">
                    <label for="inputName">Nome</label>
                    <input style={this.state.name_error ? {borderColor:"red"} : {}} onChange={this.props.updateState} value={this.props.data.name} class="form-control" id="name" name="inputName" placeholder="Nome do Paciente" required="" type="text"/>
                </div>
                <div class="form-group col-md-12">
                    <label for="inputEmail">E-mail</label>
                    <EmailInput style={this.state.email_error ? {borderColor:"red"} : {}} onChange={this.props.updateState} value={this.props.data.email} id="email" class="form-control" name="inputEmail" placeholder="E-mail" type="email"/>
                </div>
                <div class="form-group col-md-12">
                    <label for="inputPhone">Telefone</label>
                    <TelephoneInput style={this.state.telephone_error ? {borderColor:"red"} : {}} onChange={this.props.updateState} value={this.props.data.telephone} id="telephone" class="form-control" name="inputPhone" placeholder="Telefone" type="text"/>
                </div>
                <div class="form-group col-md-12">
                    <label for="inputPhone2">Telefone Resp.</label>
                    <TelephoneInput onChange={this.props.updateState} value={this.props.data.res_telephone} id="res_telephone" class="form-control" name="inputPhone2" placeholder="Telefone" required="" type="text"/>
                </div>
                <div class="clearfix"></div>
            </div>
        )
    }
}

class PatientDetail extends React.Component{
    checkStatus = () =>{
        let status = 1;
        this.props.data.appointments.forEach((app) =>{
            if(app.status == 1 && app.release == true)
                status = 1;
            else
                status = 0;
        });

        return status;
    }

    render(){
        const currentStatus = this.checkStatus();
        const status = ["Tratando","Alta"];
        return(
            <div class="scrollable">
                <div class="pX-10 peers ai-c jc-sb w-100p">

                    <div class="form-group col-md-12 m-0 p-0">

                        <div class="form-group col-md-12 m-0 p-0">
                            <div class="col-md-12 mT-20">
                                <h4 class="m-0  mB-10">
                                    <b>Dados do Paciente</b>
                                </h4>
                            </div>

                            <div class="form-group col-md-12 mB-10">
                                <label class="fsz-xs m-0 c-client-default">
                                    Nome
                                </label>
                                <p class="m-0">{this.props.data.name}</p>
                            </div>

                            <div class="form-group col-xs-12">
                                <label class="fsz-xs m-0 c-client-default">
                                    CPF
                                </label>
                                <p class="m-0">{this.props.data.cpf}</p>
                            </div>
                            <div class="form-group col-xs-12">
                                <label class="fsz-xs m-0 c-client-default">
                                    RG
                                </label>
                                <p class="m-0">{this.props.data.rg}</p>
                            </div>
                            <div class="form-group col-xs-12">
                                <label class="fsz-xs m-0 c-client-default">
                                    Data de nascimento
                                </label>
                                {/*<p class="m-0">{this.props.data.birthDate}
                                    <span class="c-client-secondary">(47 anos)</span>
                                </p>*/}
                            </div>
                            <div class="form-group col-xs-6">
                                <label class="fsz-xs m-0 c-client-default">
                                    Estado civil
                                </label>
                                <p class="m-0">{this.props.data.civil_state}</p>
                            </div>
                            <div class="form-group col-xs-6">
                                <label class="fsz-xs m-0 c-client-default">
                                    Profissão
                                </label>
                                <p class="m-0">{this.props.data.profession}</p>
                            </div>
                            <div class="form-group col-xs-12">
                                <label class="fsz-xs m-0 c-client-default">
                                    E-mail
                                </label>
                                <p class="m-0">{this.props.data.email}</p>
                            </div>

                            <div class="form-group col-xs-12 bdT pT-20">
                                <label class="fsz-xs m-0 c-client-default">
                                    Endereço
                                </label>
                                {this.props.data.street ?
                                <p class="m-0 mB-10">
                                    {this.props.data.street + " " + this.props.data.number + " - " + this.props.data.city + " - " + this.props.data.state}
                                </p>
                                :<p class="m-0 mB-10">Não Definido</p>}
                                <p class="m-0  mB-10">
                                    <label class="fsz-xs m-0 c-client-default w-100p">CEP</label>
                                    {this.props.data.cep}</p>
                                <p class="m-0">
                                    <label class="fsz-xs m-0 c-client-default w-100p">Complemento</label>
                                    {this.props.data.complement}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-100p pX-10 pY-5 ai-c  bdT">

                    <div class="fsz-xs mT-10 c-client-default">Médico Atual:</div>
                    <p class="m-0">Nenhum</p>
                    <div class="fsz-xs mT-10 c-client-default">Status:</div>
                    <p class="m-0">{status[currentStatus]}</p>
                </div>

                 <div class="pX-10 bdT peers jc-c w-100p flex-footer">
                    <div class="p-0  ai-c pR-10">
                        <div class="fsz-xs  mT-10 c-client-default">Vinculado em:</div>
                        <h4 class="m-0 fsz-xs">{this.props.data.createdAt}</h4>
                    </div>
                    {this.props.data.appointments.length > 0 ?
                    <div class=" p-0 ai-c pL-10">
                        <div class="fsz-xs mT-10 c-client-default">Primeiro atendimento:</div>
                        <h4 class="m-0 fsz-xs">{this.props.data.appointments[0].date.split(" ")[0]}
                            <i class="fa fa-clock-o mL-5 c-client-default"></i>{this.props.data.appointments[0].date.split(" ")[1]}</h4>
                    </div> : <div></div>}
                </div>
            </div>
        )
    }
}

class AppointmentDetail extends React.Component{
    render(){
        return(
            <div class="peers ai-c jc-sb p-10 bdB">
                <h5 class="m-0">
                    <b>Consulta {this.props.id}</b>
                    <br/>
                    <b>{this.props.date}</b> - {(this.props.isClinic ? "Clínica" : "Domiciliar") + " " +this.props.hour}h</h5>
                <h5 class="c-client-default m-0 p-0">
                    <b>R$ {server.appointmentPrice.toString().replace(".",",") + "0"}</b>
                </h5>
            </div>
        )
    }
}

class PaymentTab extends React.Component{
    state = {
        page: 0
    }

    loadBoxes = () =>{
        let html = [];
        Object.keys(this.props.selectedDates).forEach((key) =>{
            let data = this.props.selectedDates[key].date.split(" ");
            let isClinic = this.props.selectedDates[key].isClinic;
            html.push(<AppointmentDetail key={key} isClinic={isClinic} date={data[0]} hour={data[1]} />)
        });

        return html;
    }

    nextPage = () =>{
        if(this.state.page == 0)
            if(Object.keys(this.props.selectedDates).length > 0)
                this.setState({page:1});
            else
                this.props.alert("Faltando Informações!", "Selecione uma data para o atendimento", "warning");
        else{
            this.props.close();
            this.props.finish();
        }
    }

    render(){
        const boxes = this.loadBoxes();
        const open = this.props.open == true ? 0 : "-100%";
        let totalPay = server.appointmentPrice * boxes.length
        totalPay = parseFloat(totalPay.toString()).toFixed(2).toString().replace(".",",")
        return(
            <div style={{right: open}} class="col2-app__side-details jc-fs bdL bgc-white mobile-scroll">
                <div class="inner-content ">
                    <div class="bdB">
                        <div class="w-100p ta-c  h-100p">
                            <h3 class="ta-c mB-0">Resumo</h3>
                            <span class="fsz-xs c-client-secondary"></span>
                            <hr class="small bdc-client-default mY-10"/>
                        </div>

                        <div class="col-md-12 peers jc-c pY-20">
                            <div onClick={() => this.setState({page:0})} class="peers ai-c mX-5">
                                <span class={(this.state.page == 0 ? "bgc-client-default" : "bgc-client-secondary") + " step-number mR-5 p-5 c-client-default-inverse"}>1</span>
                                <span class={(this.state.page == 0 ? "c-client-default" : "c-client-secondary") + " step-text"}>
                                   Resumo
                                </span>
                            </div>
                            <div class="peers ai-c mX-5">
                                <span class={(this.state.page == 1 ? "bgc-client-default" : "bgc-client-secondary") + " step-number mR-5 p-5 c-client-default-inverse"}>2</span>
                                <span class={(this.state.page == 1 ? "c-client-default" : "c-client-secondary") + " step-text"}>Pagamento</span>
                            </div>
                        </div>
                        <button onClick={this.props.close} type="button" class="open-details btn btn-clear pX-5 pY-0 pos-a t-20 r-10 bdrs-2 cur-p c-client-secondary">
                            <i class="material-icons">close</i>
                        </button>
                    </div>
                    <div class="p-10 mobile-scroll scrollable">
                    {this.state.page == 0 ? 
                        <div class="aba1-data">
                            <div class="p-10 summary mobile-scroll__inner">
                                {boxes}
                                <div class="p-20 peers jc-sb">
                                    <h5 class="c-client-default m-0">
                                        <b>Total a pagar</b>
                                    </h5>
                                    <h4 class="m-0">
                                        <b>R$ {totalPay}</b>
                                    </h4>
                                </div>
                                <div class="peers w-100p jc-c p-10">
                                    <button onClick={this.props.close} class="another-data open-details btn btn-clear peers ai-c pX-5 pY-0 bdrs-2 mR-3 cur-p c-client-default" type="button">
                                        <i class="fa fa-plus-circle fsz-xl mR-5"></i>
                                        Adicionar mais
                                    </button>
                                </div>
                            </div>
                        </div>
                        :
                        <div class="aba2-data">
                            <div class="peers jc-sb">
                                <h4 class="m-0">
                                    <b>Forma de pagamento</b>
                                </h4>
                                <div class="form-group pX-10 mB-10 col-sm-12 w-100p">
                                    <div class="radio radio-client-default">
                                        <input type="radio" name="forma" id="radio-1" value="cartao-credito"/>
                                        <label for="radio-1">Cartão de crédito</label>
                                    </div>
                                    <div class="radio radio-client-default">
                                        <input type="radio" name="forma" id="radio-2" value="cartao-debito"/>
                                        <label for="radio-2">Cartão de débito</label>
                                    </div>
                                    <div class="radio radio-client-default">
                                        <input type="radio" name="forma" id="radio-3" value="dinheiro"/>
                                        <label for="radio-3">Dinheiro (à vista)</label>
                                    </div>
                                    <div class="radio radio-client-default">
                                        <input type="radio" name="forma" id="radio-4" value="cheque"/>
                                        <label for="radio-4">Cheque</label>
                                    </div>
                                </div>
                                <div class="col-md-12 m-0 p-0 w-100p">
                                    <div class="col-md-12 mB-10">
                                        <label for="inputCreditCardNumber">Numero do cartão</label>
                                        <input class="form-control" name="inputCreditCardNumber" placeholder="Número do cartão" required="" type="text"/>
                                    </div>
                                    <div class="col-md-12 mB-10">
                                        <label for="inputCreditCardName">Nome</label>
                                        <input class="form-control" name="inputCreditCardName" placeholder="Nome impresso no cartão" required="" type="text"/>
                                    </div>
                                    <div class="col-md-6 mB-10">
                                        <label for="inputCreditCardGoodThru">Vencimento</label>
                                        <input class="form-control" name="inputCreditCardGoodThru" placeholder="99/99" required="" type="text"/>
                                    </div>
                                    <div class="col-md-6 mB-10">
                                        <label for="inputCreditCardCVV">CVV</label>
                                        <input class="form-control" name="inputCreditCardCVV" placeholder="CVV" required="" type="text"/>
                                    </div>
                                </div>
                                <div onClick={this.nextPage} class="m-20 peers jc-c w-100p">
                                    <button class="btn btn-default aba1" type="button">Pagar</button>
                                </div>
                            </div>

                        </div>
                    }

                    </div>

                    <div class="bdT p-10 peers jc-sb ai-c bgc-client-default">

                        <div class="peers ai-c">
                            <span class="step-number bgc-pink-500 c-white mL-10">{this.state.page + 1}</span>
                            <div class="mL-10">
                                <h4 class="m-0 c-client-default-inverse fsz-sm">{this.state.page == 0 ? "Resumo" : "Pagamento"}</h4>     
                            </div>
                        </div>

                            <button onClick={this.nextPage} class="aba2 fsz-xs btn btn-clear peers ai-c pX-5 pY-0 bdrs-2 mR-3 cur-p c-client-default-inverse" type="button">
                                {this.state.page == 0 ? "Pagamento" : "Pagar"}
                                <i class="fa fa-angle-right fsz-md"></i>
                            </button>
                    </div>
                </div>
            </div>
                
        )
    }
}

class ScheduleFisioterapist extends React.Component{
    state = {
        patient:null,
        cpf:"",
        lock:false,
        appointments:0,
        days:1,
        alert:false,
        modal:false,
        doctor: "Nenhum",
        name_error: false,
        email_error: false,
        telephone_error:false,
        cpf_error:false,
        telephone: "",
        name: "",
        email: "",
        open:false,
        selectedDates: {},
        key: 0,
        bookedHours:{},
        hours:[],
        sideActive: false,
        page:0,
        lockModal: false,
    }

    componentWillMount(){
        this.loadBooked();
    }

    loadBooked = () =>{
        const hours = {};
        let bookedHours = {};
        let that = this;

        // GET INTERVALS
        const intervals = server.user.intervals;
        intervals.forEach((interval) =>{
            const label = (interval.isClinic == 1 ? "1" : "0") + "-" + interval.day;
            if(hours[label] == null) hours[label] = [];
            hours[label] = [...hours[label],...range(hour_to_Min(interval.start), 
                                            hour_to_Min(interval.end + 30), 30).map((i) => min_to_Hour(i))];
        })

        server.get("fisioterapists/" + server.user.id + "/patients", (patients) =>{
            patients.forEach((patient) =>{
                patient.appointments.forEach((appointment) =>{
                    if(appointment.fisioterapistId == server.user.id)
                        bookedHours[appointment.date] = {name:patient.name,email:patient.email,telephone:patient.telephone,start:appointment.date,clinic:appointment.onClinic}
                })
            })
    
            that.setState({selectedDates:{},hours:hours,bookedHours:bookedHours});
        })
    }

    updateState = (e) =>{
        this.setState({[e.target.id]:e.target.value})
    }

    lockDates = (dates, desc, fisioterapist) =>{
        this.setState({lockModal: false});

        if(dates.length == 0){
            this.props.alert("Horários travados com sucesso!", "Para destravar aperte nos horários travados.", "success");
            return this.loadBooked();
        }

        let current = this.state.selectedDates[dates.pop()];
        
        let date_info = current.date.split(" ");
        let object = {hour: date_info[1], day:date_info[0], description:desc.description, weekly_period:desc.weekly_period}

        server.post("fisioterapists/" + server.user.id + "/timelocks", object, () =>{
            this.lockDates(dates, desc, fisioterapist);
        });
    }

    fetch_patient = () =>{
      if(this.state.cpf && !this.state.cpf.includes("_")){
          if(!this.state.fetch){
            let cpf = this.state.cpf.replace(/\./g, '').replace(/\-/,'')
            this.setState({fetch:true})
            server.get("users/cpf/" + cpf, data=>{
              if(data.id){
                    server.get("patients/" + server.user.id + "/appointments", appData =>{
                        // Calculating total attended appointments
                        let attended = 0; 
                        appData.forEach(element => {
                            if(element.charged) attended+= 1;
                        });

                        data["appointments"] = appData;

                        console.log(data["appointments"])

                        // Calculating last doctor
                        const lastAppointment = appData[appData.length - 1];
                        const doctorId = lastAppointment != null ? lastAppointment.doctor_id : null;

                        if(doctorId != null)
                            server.get("users/" + doctorId, d_data =>{
                                this.setState({doctor:d_data.name})
                            });

                        // Calculating status
                        let status = "Tratando";
                        if(lastAppointment && lastAppointment.release == true) status = "Alta";

                        this.setState({patient:data,attended:attended,status:status})
                    })
              }else{
                this.setState({alert:true, message:"Paciente não cadastrado no sistema."})
              }
            })
          }
      }else if(this.state.fetch){
        this.setState({fetch:false,patient:null})
      }
    }

    appointment_boxes = () =>{
      let content = []
      for(let i = 0; i < this.state.appointments; i++){
          content.push(<CreateAppointment onChange={(result) => this.setState({["appointment"+i]:result}, () => console.log(this.state["appointment"+i]))} number={i + 1}/>)
      }
      return content
    }

    validate = () => {
        this.setState({cpf_error:false,name_error:false,telephone_error:false,email_error:false,appointments_error:false})
        if(this.state.cpf.indexOf("_") != -1 || this.state.cpf == ""){
            this.props.alert("Falta Informações!","Digite um CPF válido.","warning")
            return false;
        };

        if(this.state.patient == null && (this.state.name == "" || this.state.name == null)){
            this.props.alert("Falta Informações!","Está faltando o nome do paciente.","warning")
            return false;
        };

        if(this.state.patient == null && (this.state.email == "" || this.state.email == null)){
            this.props.alert("Falta Informações!","Está faltando o email do paciente.","warning")
            return false;
        };

        if(this.state.patient == null && (this.state.telephone == "" || this.state.telephone == null)){
            this.props.alert("Falta Informações!","Está faltando o telefone do paciente.","warning")
            return false;
        };

        if(this.state.selectedDates.length == 0){
            this.props.alert("Falta Informações!", "Selecione pelo menos uma data", "warning");
            return false
        }

      this.state.patient == null ? this.create_patient() : this.complete(null);
    }

    get_appointment_data = () =>{
      console.log(this.state.patient.appointments)
      if(this.state.patient && this.state.patient.appointments){
        for(let i = this.state.patient.appointments.length -1; i >= 0; i--){
          if(this.state.patient.appointments[i].fisioterapistId == server.user.id){
            return this.state.patient.appointments[i]
          }
        }
      }
    }

    createAppointments = (appData, selectedDates) =>{
        if(selectedDates.length == 0){
            this.props.alert("Consultas criadas!","Para realizar a consulta entre no módulo atender!","success");
            return this.loadBooked();
        }

        let current = selectedDates.pop();
        let that = this;

        appData['date'] = this.state.selectedDates[current].date;
        appData['clinic'] = this.state.selectedDates[current].isClinic;
        server.create_appointment(appData, (data) => that.createAppointments(appData, selectedDates));
    }

    create_patient = () =>{
        let data = {};
        let fisioterapist = server.user;
        data['cpf'] = this.state.cpf;
        data['telephone'] = this.state.telephone;
        data['email'] = this.state.email;
        data['name'] = this.state.name;

        if(this.state.name == ""){
            this.setState({name_error:true});
            this.props.alert("Falta Informações!","Digite um nome válido.","warning")
            return false
        }

        if(this.state.telephone == null || this.state.telephone == "" || this.state.telephone.replace(/_/g,"").length < 13){
            this.setState({telephone_error:true});
            this.props.alert("Falta Informações!","Digite um telefone válido.","warning")
            return false
        }

        if(this.state.email.indexOf("@") == -1){
            this.setState({email_error:true});
            this.props.alert("Falta Informações!","Digite um email válido.","warning")
            return false
        }
        
        data['cpf'] = data['cpf'].replace(/\./g,"").replace(/\-/g,"");
        data['telephone'] = data['telephone'].replace(/\(/g, "").replace(/\)/g, "").replace(/\_/g,"").replace(/\-/g,"");

        let that = this;

        server.post("users", data, (patient) =>{
            that.complete(patient);
        });
    }

    complete = (patient = null) =>{
        let data = {};
        let appointments = [];
        let clinic = false;

        if (patient == null) patient = this.state.patient;

        Object.keys(this.state.selectedDates).forEach((key) =>{
            appointments.push(this.state.selectedDates[key].date);
            clinic = this.state.selectedDates[key].isClinic;
        })

        data['clinic'] = clinic;
        data['price'] = server.appointmentPrice * appointments.length;
        data['cpf'] = patient["cpf"]
        data['telephone'] = patient["telephone"]
        data['email'] = patient["email"]
        data['name'] = patient["name"]
        data['fisioterapistId'] = server.user.id;
        data['evaluation'] = false;
        data['charged'] = true;
        data['dates'] = JSON.stringify(appointments);

        server.post("appointments", data, (data) =>{
            server.get("appointments/" + data.id + "/charge", () => {})
            this.props.alert("Sucesso","Consultas marcadas com sucesso!","success")
            this.loadBooked();
        })
    }

    nextPage = () =>{
        if(this.state.page == 2)
            this.validate();
        else if(this.state.page == 0)
            this.setState({page:this.state.page + 1,open:true});
        else
            this.setState({page:this.state.page + 1});
    }

    render(){
        this.fetch_patient();
        let patientName = this.state.name ? this.state.name : this.state.patient ? this.state.patient["name"] : "Agendar";
        patientName = patientName.split(" ")[0];
        return(
            <div style={{width:"100%"}} key={this.state.key}>
                <div class={this.state.sideActive == true ? "side-active" + " col2-app" : "" + " col2-app"}>
                    <div class="col2-app__side-nav peers bdR bgc-white mobile-scroll">
                        <div class="w-100p patient-management-data">
                            <div class="w-100p ai-c jc-sb content-header search-flex">
                                <div class="p-10 w-100p">
                                    <CpfInput value={this.state.cpf} onChange={this.updateState} id="cpf" class="form-control" name="inputCPF" placeholder="Validar CPF" type="text"/>
                                </div>
                                <button onClick={() => this.setState({sideActive: false})} type="button" class="page-side-toggle d-n@md+ btn btn-clear pX-5 pY-0 t-20 r-2  bdrs-2 cur-p c-client-secondary">
                                    <i class="material-icons">close</i>
                                </button>
                            </div>
                            
                            {this.state.patient == null ?
                                <PatientRegister updateState={this.updateState} data={this.state} />:
                                <PatientDetail data={this.state.patient} />
                            }
                        </div>
                    </div>
                    <div class="col2-app__wrapper ">
                        <div style={{overflow:"auto"}} class="col2-list inner-content">
                            <div class="peers w-100p ai-c jc-sb content-header">
                                <div class="content-header__left">
                                    <button onClick={() => this.setState({sideActive:true})} type="button" class="page-side-toggle d-n@md+ btn btn-clear pX-5 pY-0  bdrs-2 mR-10 cur-p c-client-secondary">
                                        <i style={{fontSize:30}} class="fa fa-user"></i>
                                    </button>
                                    <div class="content-header__title">
                                        <h3 class="m-0">
                                            Agenda
                                        </h3>
                                    </div>

                                </div>
                                {Object.keys(this.state.selectedDates).length > 0 ?
                                <div className="btn-group peers ai-c" role="group">
                                    <button className="btn btn-default" onClick={() => this.setState({lockModal: true})}>
                                        Trancar
                                    </button>
                                </div>
                                :<div></div>
                                }
                                <div class="btn-group peers ai-c" role="group">
                                    <button onClick={() => this.setState({open:true})} class="d-n@sm- aba1 open-details btn btn-clear peers ai-c pX-5 pY-0 bdrs-2 mR-3 cur-p c-client-default" type="button">
                                        <i class="fa fa-list-alt fsz-xl"></i>
                                        Resumo
                                    </button>

                                    <span class="d-n@sm- badge badge-pill bgc-pink-500 c-white">{Object.keys(this.state.selectedDates).length}</span>
                                </div>
                            </div>
                            <Calendar openSide={() => this.setState({sideActive:true},() => console.log("tentei"))} userData={this.state.userData} bookedHours={this.state.bookedHours} selectedDates={this.state.selectedDates} updateState={this.updateState} dates={this.state.hours}/>
                        </div>
                    </div>
                    <PaymentTab page={this.state.page} alert={this.props.alert} finish={this.validate} selectedDates={this.state.selectedDates} close={()=>this.setState({open:false, page:0})} open={this.state.open}/>
                    {this.state.open ? <div></div> :
                    <div style={{position: "fixed", bottom: 0, width: "100%",zIndex:10000}} class="bdT p-10 peers jc-sb ai-c bgc-client-default d-n@sm+">
                        <div class="peers ai-c">
                            <span class="badge badge-pill bgc-pink-500 c-white mL-10">{Object.keys(this.state.selectedDates).length}</span>
                            <div>
                                <h4 class="m-0 c-client-default-inverse">{patientName}</h4>
                            </div>
                        </div>

                        <button onClick={this.nextPage} class="aba1 open-details btn btn-clear peers ai-c pX-5 pY-0 bdrs-2 mR-3 cur-p c-client-default-inverse fsz-md" type="button">
                            {this.state.page == 0 ? "Resumo" : this.state.page == 1 ? "Pagamento" : "Completar"}
                            <i class="fa fa-angle-right fsz-xl"></i>
                        </button>
                    </div>
                    }
                </div>
                <div class="bcg-overlay open-details"></div>
                <LockModal lock={(desc) => this.lockDates(Object.keys(this.state.selectedDates) ,desc, JSON.parse(localStorage.getItem("user")))} close={() => this.setState({lockModal:false})} open={this.state.lockModal}/>
            </div>
        )
    }
}

export default ScheduleFisioterapist;



// WEBPACK FOOTER //
// ./src/pages/schedule/ScheduleFisioterapist.js